export enum LocalStorageKey {
  BOOKING_ID = 'BOOKING_ID',
  PAGE_URL = 'PAGE_URL',
  CHECKOUT_ATTEMPT = 'CHECKOUT_ATTEMPT'
}
